import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { FormikRadioGroup } from 'components/Formik/FormikRadioGroup'
import { useFormikContext } from 'formik'
import { RequiredDot } from 'pages/Survey/components/RequiredDot'
import { SingleChoiceQuestion } from 'pages/Survey/types'
import { useLangContext } from 'store/useLangContext'
import { fontFamilies } from 'theme/styles.utils'
import { TranslationsKeys } from 'utils/createTranslationKey'
import { useGetObjectTranslation } from 'utils/useGetObjectTranslation'

export const SurveySingleChoice = ({ question }: { question: SingleChoiceQuestion }) => {
  const translatedTitle = useGetObjectTranslation(question.translation, 'title')
  const { i18n } = useTranslation()
  const { setFieldValue } = useFormikContext()
  const { languages } = useLangContext()
  const defaultLangCode = languages?.find((lang) => lang.default)?.language.code

  return (
    <Box>
      <Typography fontFamily={fontFamilies.default} variant="h4" fontWeight="bold">
        <>
          {translatedTitle}
          {question.isRequired ? <RequiredDot /> : ''}
        </>
      </Typography>
      <FormikRadioGroup
        name={question.id}
        controlLabels={question.options.map((option) => ({
          label: (option.translation?.[i18n.language]?.title ||
            option.translation?.en?.title ||
            option.translation?.[defaultLangCode]?.title ||
            '') as TranslationsKeys,
          value: option.id,
        }))}
        onChange={(event, value) => setFieldValue(question.id, value)}
        labelProps={{ variant: 'h4', fontWeight: 'normal', fontFamily: fontFamilies.default }}
        controlsProps={{ sx: (theme) => ({ color: theme.palette.primary.main, fontFamily: fontFamilies.default }) }}
      />
    </Box>
  )
}
